export type PyramidLoadPercentageRule = {
  minReps: number;
  maxReps: number;
  display: string;
  persistValue: number;
};

export const PYRAMID_LOAD_PERCENTAGE_TABLE: readonly PyramidLoadPercentageRule[] = [
  { minReps: 1, maxReps: 1, display: '100', persistValue: 100 },
  { minReps: 2, maxReps: 3, display: '90-95', persistValue: 90 },
  { minReps: 4, maxReps: 5, display: '85-90', persistValue: 85 },
  { minReps: 6, maxReps: 8, display: '80', persistValue: 80 },
  { minReps: 9, maxReps: 10, display: '75', persistValue: 75 },
  { minReps: 11, maxReps: 12, display: '70', persistValue: 70 },
  { minReps: 13, maxReps: 15, display: '65', persistValue: 65 },
  { minReps: 16, maxReps: 20, display: '60', persistValue: 60 },
  { minReps: 21, maxReps: 25, display: '55', persistValue: 55 },
  { minReps: 26, maxReps: 30, display: '50', persistValue: 50 },
];

const parseRepetitionCount = (value?: number | string | null) => {
  if (typeof value === 'number' && Number.isInteger(value) && value > 0) {
    return value;
  }

  const parsedValue = Number.parseInt(String(value ?? ''), 10);

  return Number.isInteger(parsedValue) && parsedValue > 0 ? parsedValue : null;
};

export const getPyramidLoadPercentageRule = (repetitions?: number | string | null) => {
  const repetitionCount = parseRepetitionCount(repetitions);

  if (repetitionCount == null) {
    return null;
  }

  return PYRAMID_LOAD_PERCENTAGE_TABLE.find((rule) => (
    repetitionCount >= rule.minReps && repetitionCount <= rule.maxReps
  )) ?? null;
};

export const getPyramidLoadPercentageDisplay = (repetitions?: number | string | null) => (
  getPyramidLoadPercentageRule(repetitions)?.display ?? ''
);

export const getPyramidLoadPercentageValue = (repetitions?: number | string | null) => (
  getPyramidLoadPercentageRule(repetitions)?.persistValue ?? null
);
